import React from 'react'
import styled from 'styled-components'

const StickyStyle = styled.div`
  position: sticky;
  z-index: 1900;
  top: 0;
`

const Sticky = ({ children }) => (
  <StickyStyle>
    {children}
  </StickyStyle>
)

Sticky.propTypes = {}
Sticky.defaultProps = {}

export default Sticky



// WEBPACK FOOTER //
// ./src/components/Sticky/index.js